import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {DocumentationPage} from './DocumentationPage'

const DocumentationWrapper = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Accueil',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Documentation
      </PageTitle>
      <DocumentationPage />
    </>
  )
}

export {DocumentationWrapper}
